import React from "react";
import { useNavigate } from "react-router-dom";

export default function ActionCenter({ actions = [], loading = false, error = "" }) {
  const navigate = useNavigate();

  return (
    <section className="action-center card">
      <div className="card-title">Action Center</div>
      {loading ? (
        <p className="text-muted">Checking for items that need attention...</p>
      ) : error ? (
        <p className="text-muted">Unable to load action items right now.</p>
      ) : actions.length === 0 ? (
        <p className="text-muted">You're all caught up. No pending actions.</p>
      ) : (
        <div className="action-list">
          {actions.map((action, index) => (
            <button key={`${action.label}-${index}`} type="button" onClick={() => action.path && navigate(action.path)}>
              <span>{action.label}</span>
              {action.path && <strong>View</strong>}
            </button>
          ))}
        </div>
      )}
    </section>
  );
}
